import React from 'react'
import './Eligibility_criteria_details_content.css'

function Eligibility_criteria_details_content() {
    return (
        <>
            <section className="Terms_Conditions_content_holder">
                <div className="container">
                    <div className="Terms_Conditions_content">

                        <div className="text_holder">
                            <h4>Eligibility Criteria & Required Documents</h4>
                            <p>
                               Share your details to help us understand your requirements. Our team will review your information and guide you toward suitable financial options offered by third-party institutions.
                            </p>
                        </div>

                        <div className="text_holder">
                            <h4>1. Income Criteria (General Guideline)</h4>
                            <ul>
                                <li>Minimum monthly salary: <strong>₹20,000 and above</strong>.</li>
                                <li>For self-employed: Minimum ITR of <strong>₹5–6 Lakhs per annum</strong>.</li>
                                <li>Stable income source from salary or business is required.</li>
                            </ul>
                        </div>

                        <div className="text_holder">
                            <h4>2. Documents Required</h4>
                            <ul>
                                <li><strong>Identity Proof:</strong> Aadhaar Card / PAN Card / Passport / Voter ID</li>
                                <li><strong>Address Proof:</strong> Aadhaar / Utility Bill / Rent Agreement / Passport</li>
                                <li><strong>Income Proof:</strong> Last 3 months’ Salary Slips / 6 months’ Bank Statements / ITR for self-employed</li>
                                <li><strong>Photograph:</strong> Recent passport-size photo</li>
                            </ul>
                        </div>

                        <div className="text_holder">
                            <h4>3. CIBIL Score & Other Requirements</h4>
                            <ul>
                                <li>Minimum CIBIL Score: <strong>≥ 700 preferred</strong>.</li>
                                <li><strong>Age:</strong> 21 – 58 years (salaried), 21 – 65 years (self-employed).</li>
                                <li><strong>Employment:</strong> Minimum 3 months in current job (salaried) or 2 years in business (self-employed).</li>
                            </ul>
                        </div>

                        <div className="text_holder">
                            <h4>4. Financial Information</h4>
                            <ul>
                                <p><b>Interest Rates:</b></p>
                                <ul className='mb-3'>
                                    <li>Starting from 10.50% p.a.</li>
                                </ul>

                                <p><b>APR (Annual Percentage Rate):</b></p>
                                <ul>
                                    <li> Typically starts from 11%</li>
                                </ul>
                            </ul>
                        </div>

                        <div className="text_holder">
                            <h4>5. Contact & Support</h4>
                            <ul>
                                <p>For queries related to eligibility and required documents, contact us at:</p>
                                <ul>
                                    <li>Mobile number to display -  <b>8956368061</b></li>
                                    <li>WhatsApp number for customer queries - <b>8956368061</b></li>
                                </ul>
                            </ul>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Eligibility_criteria_details_content
